module.exports = __webpack_public_path__ + "static/media/camo_assets_icon.d67d55c3.svg";